"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var Stack_1 = __importDefault(require("@mui/material/Stack"));
var react_redux_1 = require("react-redux");
var TextButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/TextButton"));
var hooks_1 = require("containers/ConfirmationModal/hooks");
var hooks_2 = require("utils/hooks");
var single_1 = require("utils/selectors/single");
var EnabledTextButton = function (_a) {
    var checked = _a.checked, props = __rest(_a, ["checked"]);
    return ((0, jsx_runtime_1.jsx)(TextButton_1.default, __assign({ icon: checked ? pro_light_svg_icons_1.faCheck : pro_light_svg_icons_1.faTimes, color: checked ? 'green' : 'red', size: "small", fullWidth: true }, props)));
};
var TestTrackToggles = function (_a) {
    var company = _a.company;
    var rechargerCompany = (0, react_redux_1.useSelector)(single_1.selectMyRechargerCompany);
    var promptConfirm = (0, hooks_1.useConfirm)();
    var _b = __read((0, hooks_2.useSubmitter)('companies', company.id), 2), updateCompany = _b[0], isUpdatingCompany = _b[1];
    var _c = __read((0, hooks_2.useSubmitter)('recharger_companies', company.id), 2), updateRechComp = _c[0], isUpdatingRechComp = _c[1];
    var isTest = company.isTest;
    var isTracking = !(rechargerCompany === null || rechargerCompany === void 0 ? void 0 : rechargerCompany.noTrackTest);
    var submitFlag = function (type) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, promptConfirm("Are you sure that you want to change the company's attribute for ".concat(type === 'test' ? 'Is Test' : 'Tracking', "?"), 'You can always revert this.', 'green', 'Yes')];
                case 1:
                    response = _a.sent();
                    if (!response) return [3 /*break*/, 5];
                    if (!(type === 'test')) return [3 /*break*/, 3];
                    return [4 /*yield*/, updateCompany({ isTest: !company.isTest })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3:
                    if (!(type === 'tracking')) return [3 /*break*/, 5];
                    return [4 /*yield*/, updateRechComp({ noTrackTest: !(rechargerCompany === null || rechargerCompany === void 0 ? void 0 : rechargerCompany.noTrackTest) })];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)(Stack_1.default, __assign({ direction: "row", pt: 1 }, { children: [(0, jsx_runtime_1.jsxs)(EnabledTextButton, __assign({ checked: !isTest, onClick: function () { return submitFlag('test'); }, isSending: isUpdatingCompany }, { children: [!isTest && 'Is Not ', "Test"] })), (0, jsx_runtime_1.jsx)(EnabledTextButton, __assign({ checked: isTracking, onClick: function () { return submitFlag('tracking'); }, isSending: isUpdatingRechComp }, { children: "Tracking" }))] })));
};
exports.default = TestTrackToggles;
